<script lang="ts">

    import {Avatar, Tooltip} from "flowbite-svelte";

    export let customer: any;

    export let size = "md"

    export let bgColor = customer.avatarFile ? "bg-transparent" : "bg-gray-100"

    let sizes = {
        sm: "h-7 w-7",
        md: "h-10 w-10",
        lg: "h-12 w-12",
        xl: "h-14 w-14",
        "2xl": "h-16 w-16",
        "3xl": "h-32 w-32"
    }

    let avatarClass = 'relative flex justify-center items-center rounded ' + bgColor + ' dark:bg-gray-600 text-gray-600 dark:text-gray-300 ' + sizes[size]



    let fontMapping = {
        sm: "text-xs",
        md: "text-base",
        lg: "text-lg",
        xl: "text-xl",
        "2xl": "text-2xl",
        "3xl": "text-3xl"
    }

    const ignore = ['GmbH', 'UG', 'KG', 'SE', 'Ltd', 'AG']
    let short = customer.name.split(' ').map((n) => {
        return n[0].match(/[a-z0-9]/i) && !ignore.includes(n) ? n[0] : ''
    }).join('');




</script>
{#if customer}
<Avatar
    rounded
    data-name="{customer.name}"
    src={customer.avatarFile ? 'https://c-' + customer.uuid + '.s3.eu-north-1.amazonaws.com/' + customer.avatarFile : undefined}
    class="{avatarClass}"
>{!customer.avatarFile ? short : ''}</Avatar>
    <Tooltip placement="right" >{customer.name}</Tooltip>
{/if}




